'use strict';

angular
.module('aq.filters.time')
.filter('userFriendlyDate', function ($filter) {
    return function (date) {
        return date ? $filter('formatDate')(date, 'MM/DD/YYYY') : 'Not set';
    }
});